import * as React from 'react';
import { Pressable, View } from 'react-native';
import { cn } from '@/lib/utils';
import { Modal } from './modal';
import { Text } from './text';

interface ModalAction {
  label: string;
  onPress: () => void;
  disabled?: boolean;
}

interface DismissibleModalProps {
  visible: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  primaryAction?: ModalAction;
  secondaryAction?: ModalAction;
  className?: string;
  testID?: string;
}

function DismissibleModal({
  visible,
  onClose,
  title,
  children,
  primaryAction,
  secondaryAction,
  className,
  testID,
}: DismissibleModalProps) {
  return (
    <Modal
      visible={visible}
      onClose={onClose}
      backdropPress={true}
      animationType="fade"
      className={className}
      testID={testID}
    >
      <View className="bg-card rounded-xl p-6">
        <View className="flex-row items-center justify-between mb-4">
          <Text className="text-xl font-semibold text-card-foreground">
            {title}
          </Text>
          <Pressable
            onPress={onClose}
            accessibilityLabel="Close"
            accessibilityRole="button"
            className="p-1"
          >
            <Text className="text-muted-foreground text-lg">✕</Text>
          </Pressable>
        </View>

        <View className="mb-6">{children}</View>

        {(primaryAction || secondaryAction) && (
          <View className="flex-row justify-end gap-3">
            {secondaryAction && (
              <Pressable
                onPress={secondaryAction.onPress}
                disabled={secondaryAction.disabled}
                accessibilityLabel={secondaryAction.label}
                accessibilityRole="button"
                className="rounded-lg py-3 px-6 items-center"
              >
                <Text className="text-muted-foreground font-semibold text-base">
                  {secondaryAction.label}
                </Text>
              </Pressable>
            )}
            {primaryAction && (
              <Pressable
                onPress={primaryAction.onPress}
                disabled={primaryAction.disabled}
                accessibilityLabel={primaryAction.label}
                accessibilityRole="button"
                className={cn(
                  'bg-primary rounded-lg py-3 px-6 items-center',
                  primaryAction.disabled && 'opacity-50',
                )}
              >
                <Text className="text-primary-foreground font-semibold text-base">
                  {primaryAction.label}
                </Text>
              </Pressable>
            )}
          </View>
        )}
      </View>
    </Modal>
  );
}

export { DismissibleModal };
export type { DismissibleModalProps };
